var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0002 3.33398C10.7952 3.33398 3.3335 10.7957 3.3335 20.0007C3.3335 28.319 9.4285 35.214 17.3968 36.4657V24.8173H13.1635V20.0007H17.3968V16.329C17.3968 12.1523 19.8835 9.84565 23.6918 9.84565C25.5152 9.84565 27.4218 10.1707 27.4218 10.1707V14.2707H25.3218C23.2502 14.2707 22.6052 15.5557 22.6052 16.874V20.0007H27.2268L26.4885 24.8173H22.6052V36.4657C30.5718 35.2157 36.6668 28.3173 36.6668 20.0007C36.6668 10.7957 29.2052 3.33398 20.0002 3.33398Z",
    fill: "#0F0F0F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceIcon);
export default __webpack_public_path__ + "static/media/face_icon.ea27fdce950548ceb2a53db1aa69a96a.svg";
export { ForwardRef as ReactComponent };